import React from 'react'
import { Grid } from 'semantic-ui-react'

export const Container = ({ children }) => {
  return (
    <Grid columns={2} stackable className="h-screen !m-0">
      {children}
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/OnboardingWizard/Container.js